import {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  setScanPackPrompt,
  handleOrderComplete,
  exitUnscannableOrder,
  showOrderConfirmationIfRequired
} from '../../../actions/scanpackScanningActions';
import {getPostScanStepsFromConfigs, getPostScanConfig} from '../../../utils/postScanning/postScanConfig';
import i18n from 'i18n-js';

export default function useOrderChecks(currentOrder, bothSettings, userInfo) {
  const dispatch = useDispatch();
  const mountCompleteCheckDone = useRef(false);
  const exited = useRef(false);
  const promptsOpenedFor = useRef({orderId: null, withUserInfo: false});
  const postScanActive = useSelector(state => state.scanPackScanning.postScanPipeline?.active);
  const postScanConfig = useSelector(getPostScanConfig);

  useEffect(() => {
    if (exited.current || postScanActive) return;

    const status = currentOrder?.status;
    if (status !== 'scanned' && status !== 'cancelled') return;

    exited.current = true;
    dispatch(
      exitUnscannableOrder(
        status === 'scanned'
          ? {
              showScannedMessage: true,
              scannedOrder: {id: currentOrder?.id, increment_id: currentOrder?.increment_id}
            }
          : {showCancelledMessage: true}
      )
    );
  }, [currentOrder?.id, currentOrder?.status, postScanActive]);

  useEffect(() => {
    if (!currentOrder || !bothSettings || exited.current) return;

    const alreadyOpened =
      promptsOpenedFor.current.orderId === currentOrder.id &&
      (promptsOpenedFor.current.withUserInfo || !userInfo);
    if (!alreadyOpened) {
      promptsOpenedFor.current = {orderId: currentOrder.id, withUserInfo: !!userInfo};
      const serviceIssueOpened = checkServiceIssue();
      if (!serviceIssueOpened) dispatch(showOrderConfirmationIfRequired());
    }
    checkAlreadyComplete();
  }, [currentOrder?.id, bothSettings, userInfo]);

  const checkAlreadyComplete = () => {
    if (mountCompleteCheckDone.current) return;
    const unScannedItems = currentOrder?.unscanned_items || [];
    if (unScannedItems.length > 0) return;
    if (postScanActive) return;

    const {steps} = getPostScanStepsFromConfigs(
      postScanConfig,
      bothSettings?.data?.data?.scanpack_setting
    );

    if (steps.length) {
      mountCompleteCheckDone.current = true;
      dispatch(handleOrderComplete());
    }
  };

  const checkServiceIssue = () => {
    if (currentOrder?.status !== 'serviceissue') return false;
    const message = getServiceIssueMessage();
    dispatch(setScanPackPrompt(true, message, 'service_issue', '', false));
    return true;
  };

  const getServiceIssueMessage = () => {
    if (userInfo?.role?.add_edit_order_items) {
      return i18n.t('scanpackItem.service_Issue_msg_one');
    } else {
      return i18n.t('scanpackItem.service_Issue_msg_two');
    }
  };
}

